/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import { createSlice } from "@reduxjs/toolkit";

/**
 * State for managing the overdue appointments prompt visibility.
 */
interface AppointmentDismissedList { userId: string; appointmentId: string; dateDismissed: Date; }

export interface ArrAppointmentsState {
  dismissedList: AppointmentDismissedList[];
}

const initialState: ArrAppointmentsState = {
  dismissedList: [],
};

const addList = (state: ArrAppointmentsState, action: { payload: AppointmentDismissedList }
) => {
  state.dismissedList.push(action.payload);
};
const deleteList = (state: ArrAppointmentsState) => {
  state.dismissedList = [];
};
const clearList = (state: ArrAppointmentsState) => {
  if (!Array.isArray(state.dismissedList)) {
    state.dismissedList = [];
    return;
  }
  const days = Number(process.env.REACT_APP_DISMISS_DELETE) || 1;
  const now = new Date();
  state.dismissedList = state.dismissedList.filter(
    element => {
      const diffMs = now.getTime() - new Date(element.dateDismissed).getTime();
      const diffDays = diffMs / (1000 * 60 * 60 * 24);
      return diffDays < days;
    }
  );
};

const ArrAppointmentsSlice = createSlice({
  name: "appointments",
  initialState: initialState,
  reducers: {
    addList,
    deleteList,
    clearList,
  },
});


export const ArrAppointmentsActions = ArrAppointmentsSlice.actions;

export const selectArrAppointmentsDismissedList = (state: { arrAppointments: ArrAppointmentsState }) =>
  state.arrAppointments.dismissedList;

export default ArrAppointmentsSlice;
